export default "__VITE_ASSET__4400880e__"